/*
 * @Description: 租户管理路由
 * @Author: jiang.weiwei
 * @LastEditors: cc
 * @Date: 2017-7-21
 * @LastEditTime: 2021-01-21 14:41:13
 */
'use strict';
angular.module('tenantManageMentRouterModule', [
    'tManageMentModule',
    'allTenantManageModule',
    'allocationOfficialsModule',
    'basicInfoSettingModule',
    'infoSourceSettingModule',
    'manuAccessSettingModule',
    'servicesConfigModule',
    'productTrialModule',
    'servicesTenantInfoModule',
    'whiteListManageModule',
    'moduleManageModule',
    'moduleSettingModule',
    'regionManageModule',
    'regionSettingModule',
    'territoryPointModule',
    'brokeNewsAccountModule',
    'billingCenterModule', // 计费中心
    'productBillingInfoModule', // 产品计费信息
    'groupJudgementModule', // 原创分组判断
    'tenantTopicManageModule', // 选题配置模块
])
    .config(['$stateProvider', function($stateProvider) {
        $stateProvider.state('manageconfig.tenantmanagement.management', { // 分类词典
            url: '/management',
            views: {
                'main@manageconfig.tenantmanagement': {
                    templateUrl: './manageConfig/tenantManageMent/manageMent/manageMent_tpl.html',
                    controller: 'tManageMentCtrl'
                }
            }
        })
            .state('manageconfig.tenantmanagement.allTenantManage', {
                url: '/allTenantManage',
                views: {
                    'main@manageconfig.tenantmanagement': {
                        templateUrl: './manageConfig/tenantManageMent/allTenantManage/allTenantManage_tpl.html',
                        controller: 'allTenantManageCtrl'
                    }
                }
            })
            .state('manageconfig.tenantmanagement.billingCenter', { // 超管-计费模块中心
                url: '/billingCenter',
                views: {
                    'main@manageconfig.tenantmanagement': {
                        templateUrl: './manageConfig/tenantManageMent/billingCenter/billingCenter_tpl.html',
                        controller: 'billingCenterCtrl'
                    }
                }
            })
            .state('manageconfig.tenantmanagement.allocationOfficials', {
                url: '/allocationOfficials',
                views: {
                    'main@manageconfig.tenantmanagement': {
                        templateUrl: './manageConfig/tenantManageMent/allocationOfStateOfficials/allocaOfStateOfficials_tpl.html',
                        controller: 'allocationOfficialsCtrl'
                    }
                }
            })
            .state('manageconfig.tenantmanagement.servicesconfig', {
                url: '/servicesconfig',
                views: {
                    'main@manageconfig.tenantmanagement': {
                        templateUrl: './manageConfig/tenantManageMent/servicesConfig/servicesConfig_tpl.html',
                        controller: 'servicesConfigCtrl'
                    }
                }
            })
            .state('manageconfig.tenantmanagement.producttrial', { // 产品试用申请
                url: '/producttrial',
                views: {
                    'main@manageconfig.tenantmanagement': {
                        templateUrl: './manageConfig/tenantManageMent/productTrial/productTrial_tpl.html',
                        controller: 'productTrialCtrl'
                    }
                }
            })
            .state('manageconfig.tenantmanagement.basicInfoSetting', {
                url: '/basicInfoSetting',
                views: {
                    'main@manageconfig.tenantmanagement': {
                        templateUrl: './manageConfig/tenantManageMent/basicInfoSetting/basicInfoSetting_tpl.html',
                        controller: 'basicInfoSettingCtrl'
                    }
                }
            })
            .state('manageconfig.tenantmanagement.productBillingInfo', {
                url: '/productBillingInfo',
                views: {
                    'main@manageconfig.tenantmanagement': {
                        templateUrl: './manageConfig/tenantManageMent/productBillingInfo/productBillingInfo_tpl.html',
                        controller: 'productBillingInfoCtrl'
                    }
                }
            })
            .state('manageconfig.tenantmanagement.infoSourceSetting', {
                url: '/infoSourceSetting?tab',
                views: {
                    'main@manageconfig.tenantmanagement': {
                        templateUrl: './manageConfig/tenantManageMent/infoSourceSetting/infoSourceSetting_tpl.html',
                        controller: 'infoSourceSettingCtrl'
                    }
                }
            })
            .state('manageconfig.tenantmanagement.infoSourceSetting.hotWarning', {
                url: '/hotWarning',
                views: {
                    'main@manageconfig.tenantmanagement.infoSourceSetting': {
                        templateUrl: './manageConfig/tenantManageMent/infoSourceSetting/hotWarning/hotwarning_tpl.html',
                        controller: 'hotWarningTplCtrl'
                    }
                }
            })
            .state('manageconfig.tenantmanagement.infoSourceSetting.regionRealtedOfficials', {
                url: '/regionRealtedOfficials',
                views: {
                    'main@manageconfig.tenantmanagement.infoSourceSetting': {
                        templateUrl: './manageConfig/tenantManageMent/infoSourceSetting/regionRealtedOfficials/regionRealtedOfficials_tpl.html',
                        controller: 'regionRealtedOfficialsCtrl'
                    }
                }
            })
            .state('manageconfig.tenantmanagement.infoSourceSetting.weiboDisclose', {
                url: '/weiboDisclose',
                views: {
                    'main@manageconfig.tenantmanagement.infoSourceSetting': {
                        templateUrl: './manageConfig/tenantManageMent/infoSourceSetting/weiboDisclose/weiboDisclose_tpl.html',
                        controller: 'weiboDiscloseCtrl'
                    }
                }
            })
            .state('manageconfig.tenantmanagement.manuAccessSetting', {
                url: '/manuAccessSetting',
                views: {
                    'main@manageconfig.tenantmanagement': {
                        templateUrl: './manageConfig/tenantManageMent/manuAccessSetting/manuAccessSetting_tpl.html',
                        controller: 'manuAccessSettingCtrl'
                    }
                }
            }).state('manageconfig.tenantmanagement.serviceinfo', {
                url: '/serviceinfo',
                views: {
                    'main@manageconfig.tenantmanagement': {
                        templateUrl: './manageConfig/tenantManageMent/serviceTenantInfo/serviceTenantInfo_tpl.html',
                        controller: 'servicesTenantInfoCtrl'
                    }
                }
            }).state('manageconfig.tenantmanagement.whiteListManage', {
                url: '/whiteListManage',
                views: {
                    'main@manageconfig.tenantmanagement': {
                        templateUrl: './manageConfig/tenantManageMent/whiteListManage/whiteListManage_tpl.html',
                        controller: 'whiteListManageCtrl'
                    }
                }
            }).state('manageconfig.tenantmanagement.moduleManage', {
                url: '/moduleManage',
                views: {
                    'main@manageconfig.tenantmanagement': {
                        templateUrl:
                            './manageConfig/tenantManageMent/moduleManage/moduleManage_tpl.html',
                        controller: 'moduleManageCtrl'
                    }
                }
            })
            .state('manageconfig.tenantmanagement.regionManage', {
                url: '/regionManage',
                views: {
                    'main@manageconfig.tenantmanagement': {
                        templateUrl:
                            './manageConfig/tenantManageMent/regionManage/regionManage_tpl.html',
                        controller: 'regionManageCtrl'
                    }
                }
            })
            .state('manageconfig.tenantmanagement.moduleSetting', {
                url: '/moduleSetting',
                views: {
                    'main@manageconfig.tenantmanagement': {
                        templateUrl:
                            './manageConfig/tenantManageMent/moduleSetting/moduleSetting_tpl.html',
                        controller: 'moduleSettingCtrl'
                    }
                }
            })
            .state('manageconfig.tenantmanagement.regionSetting', {
                url: '/regionSetting',
                views: {
                    'main@manageconfig.tenantmanagement': {
                        templateUrl:
                            './manageConfig/tenantManageMent/regionSetting/regionSetting_tpl.html',
                        controller: 'regionSettingCtrl'
                    }
                }
            })
            .state('manageconfig.tenantmanagement.territoryPoint', {
                url: '/territoryPoint',
                views: {
                    'main@manageconfig.tenantmanagement': {
                        templateUrl:
                            './manageConfig/tenantManageMent/territoryPoint/territory_point.html',
                        controller: 'territoryPointCtrl'
                    }
                }
            })
            .state('manageconfig.tenantmanagement.brokeNewsAccount', {
                url: '/brokeNewsAccount',
                views: {
                    'main@manageconfig.tenantmanagement': {
                        templateUrl:
                            './manageConfig/tenantManageMent/brokeNewsAccount/brokeNewsAccount_tpl.html',
                        controller: 'brokeNewsAccountCtrl'
                    }
                }
            }).state('manageconfig.tenantmanagement.groupJudgement', {
                url: '/groupJudgement',
                views: {
                    'main@manageconfig.tenantmanagement': {
                        templateUrl: './manageConfig/tenantManageMent/groupJudgement/groupJudgement_tpl.html',
                        controller: 'groupJudgementCtrl'
                    }
                }
            }).state('manageconfig.tenantmanagement.topicManage', {
                url: '/topicManage',
                views: {
                    'main@manageconfig.tenantmanagement': {
                        templateUrl: './manageConfig/tenantManageMent/topicManage/main.html',
                        controller: 'tenantTopicManageCtrl'
                    }
                }
            });
    }]);
